import React from "react"
import "./ActivitySign.less"
import ActivitySignTable from "./ActivitySignTable"

/**
 * ActivitySign
 * @constructor
 */
const ActivitySign: React.FC = () => {

  return (
    <div className="ActivitySign">
      <ActivitySignTable />
    </div>
  )
}

export default ActivitySign